import { Modal } from "react-bootstrap";
import { ACTION_TYPE, REPORT_NAME } from "../constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useState } from "react";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useFindAllVoucherFinanceMutation } from "../../redux-toolkit/services/voucherFinanceService";
import { useBulkUploadInventoryCategoryMasterMutation, useFindAllInventoryCategoryMasterMutation, useGetInventoryCategoryMasterByIdMutation, useSaveInventoryCategoryMasterMutation, useUpdateInventoryCategoryMasterMutation } from "../../redux-toolkit/services/inventoryCategoryMasterService";
import { getInventoryCategoryMasterList, setInventoryCategoryMasterList } from "../../redux-toolkit/slices/inventoryCategoryMasterSlice";
import { useBulkUploadInventoryItemMasterMutation, useFindAllInventoryItemMasterMutation, useGetInventoryItemMasterByIdMutation, useSaveInventoryItemMasterMutation, useUpdateInventoryItemMasterMutation } from "../../redux-toolkit/services/inventoryItemMasterService";
import { getInventoryItemMasterList, setInventoryItemMasterList } from "../../redux-toolkit/slices/inventoryItemMasterSlice";
import { useBulkUploadInventoryOpeningBalanceMutation, useGetInventoryOpeningBalanceByIdMutation, useSaveInventoryOpeningBalanceMutation, useUpdateInventoryOpeningBalanceMutation } from "../../redux-toolkit/services/inventoryOpeningBalanceService";
import { useBulkUploadInventoryTransactionsMutation, useGetInventoryTransactionsByIdMutation, useSaveInventoryTransactionsMutation, useUpdateInventoryTransactionsMutation } from "../../redux-toolkit/services/inventoryTransactionsService";
import { setInventoryTransactionsList } from "../../redux-toolkit/slices/inventoryTransactionsSlice";
import { useBulkSaveAuditLogMutation, useSaveAuditLogMutation } from "../../redux-toolkit/services/auditLogService";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { getAllVoucherFinanceList, setAllVoucherFinance } from "../../redux-toolkit/slices/voucherFinanceSlice";
import { useAppSelector } from "../../redux-toolkit/hooks";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
};

const InventoryReportData = (props: Props) => {

    const localUserObj: any = getLocalStorageData("localUser");
    const dispatch = useDispatch();

    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [file, setFile]: any = useState<File | null>(null);
    const [activeTab, setActiveTab] = useState<"manual" | "bulk">("manual");


    //save
    const [saveInventoryCategoryMaster, saveInventoryCategoryMasterResponse] = useSaveInventoryCategoryMasterMutation();
    const [saveInventoryItemMaster, saveInventoryItemMasterResponse] = useSaveInventoryItemMasterMutation();
    const [saveInventoryOpeningBalanceMaster, saveInventoryOpeningBalanceMasterResponse] = useSaveInventoryOpeningBalanceMutation();
    const [saveInventoryTransactionsMaster, saveInventoryTransactionsMasterResponse] = useSaveInventoryTransactionsMutation();
    const [logAudit] = useSaveAuditLogMutation();
    const [logAuditBulk] = useBulkSaveAuditLogMutation();

    //bulk
    const [bulkSaveInventoryCategoryMaster, bulkSaveInventoryCategoryMasterResponse] = useBulkUploadInventoryCategoryMasterMutation();
    const [bulkSaveInventoryItemMaster, bulkSaveInventoryItemMasterResponse] = useBulkUploadInventoryItemMasterMutation();
    const [bulkSaveInventoryOpeningBalanceMaster, bulkSaveInventoryOpeningBalanceMasterResponse] = useBulkUploadInventoryOpeningBalanceMutation();
    const [bulkSaveInventoryTransactionsMaster, bulkSaveInventoryTransactionsMasterResponse] = useBulkUploadInventoryTransactionsMutation();

    //update
    const [updateInventoryCategoryMaster, updateInventoryCategoryMasterResponse] = useUpdateInventoryCategoryMasterMutation();
    const [updateInventoryItemMaster, updateInventoryItemMasterResponse] = useUpdateInventoryItemMasterMutation();
    const [updateInventoryOpeningBalanceMaster, updateInventoryOpeningBalanceMasterResponse] = useUpdateInventoryOpeningBalanceMutation();
    const [updateInventoryTransactionsMaster, updateInventoryTransactionsMasterResponse] = useUpdateInventoryTransactionsMutation();


    //getById mutation
    const [getInventoryCategoryMasterById, inventoryCategoryMasterByIdResponse] = useGetInventoryCategoryMasterByIdMutation();
    const [getInventoryItemMasterById, inventoryItemMasterByIdResponse] = useGetInventoryItemMasterByIdMutation();
    const [getInventoryOpeningBalanceMasterById, inventoryOpeningBalanceMasterByIdResponse] = useGetInventoryOpeningBalanceByIdMutation();
    const [getInventoryTransactionsMasterById, inventoryTransactionsMasterByIdResponse] = useGetInventoryTransactionsByIdMutation();


    //getAllData
    const [findAllInventoryCategoryMasters, findAllInventoryCategoryMastersResponse] = useFindAllInventoryCategoryMasterMutation();
    const [findAllInventoryItemMasters, findAllInventoryItemMastersResponse] = useFindAllInventoryItemMasterMutation();
    const [findAllVoucherFinanceMasters, findAllVoucherFinanceMastersResponse] = useFindAllVoucherFinanceMutation();
    //Data
    const allInventoryCategoryData: any = useAppSelector(getInventoryCategoryMasterList);
    const allInventoryItemMasterData: any = useAppSelector(getInventoryItemMasterList);
    const allVoucherFinanceData: any = useAppSelector(getAllVoucherFinanceList);
    console.log(allVoucherFinanceData,"allVoucherFinanceData");


    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER) {
                getInventoryCategoryMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });

            } else if (props.reportName === REPORT_NAME.INVENTORY_ITEM_MASTER) {
                getInventoryItemMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });

                findAllInventoryCategoryMasters({
                    token: localUserObj?.token
                })
                findAllInventoryItemMasters({
                    token: localUserObj?.token
                })
            }
            else if (props.reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE) {
                getInventoryOpeningBalanceMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
                findAllInventoryItemMasters({
                    token: localUserObj?.token
                })


            }
            else if (props.reportName === REPORT_NAME.INVENTORY_TRANSACTIONS) {
                getInventoryTransactionsMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });

                findAllInventoryCategoryMasters({
                    token: localUserObj?.token
                })
                findAllVoucherFinanceMasters({
                    token: localUserObj?.token
                })

            }

        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            if (props.reportName === REPORT_NAME.INVENTORY_ITEM_MASTER) {
                findAllInventoryCategoryMasters({
                    token: localUserObj?.token
                })
                findAllInventoryItemMasters({
                    token: localUserObj?.token
                })

            } else if (props.reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE) {
                findAllInventoryItemMasters({
                    token: localUserObj?.token
                })

            }
            else if (props.reportName === REPORT_NAME.INVENTORY_TRANSACTIONS) {
                findAllInventoryItemMasters({
                    token: localUserObj?.token
                })
                findAllVoucherFinanceMasters({
                    token: localUserObj?.token
                })

            }
        }
    }, [props.reportName]);

    const handleClose = () => {
        props.setShow(false);
    };


    const handleSubmit = (values: any) => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            if (props.reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER) {

                const payload = {
                    inventoryCategoryName: values.inventoryCategoryName,
                    description: values.description,
                    isActive: values.isActive,
                }

                saveInventoryCategoryMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.INVENTORY_ITEM_MASTER) {

                const payload = {
                    inventoryCategoryCode: values.inventoryCategoryCode,
                    itemName: values.itemName,
                    description: values.description,
                    unit: values.unit,
                    rate: values.rate,
                    dependentItemCategoryCode: values.dependentItemCategoryCode,
                    isActive: values.isActive,
                }

                saveInventoryItemMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }
            else if (props.reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE) {

                const payload = {
                    itemCode: values.itemCode,
                    quantity: values.quantity,
                    asOfDate: values.asOfDate,
                    isActive: values.isActive,
                }


                saveInventoryOpeningBalanceMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }

            else if (props.reportName === REPORT_NAME.INVENTORY_TRANSACTIONS) {

                const payload = {
                    date: values.date,
                    itemCode: values.itemCode,
                    qtyIn: values.qtyIn,
                    qtyOut: values.qtyOut,
                    relatedVoucherID: values.relatedVoucherID,
                    isActive: values.isActive,
                }

                saveInventoryTransactionsMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }


        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER) {

                const payload = {
                    id: values.id,
                    inventoryCategoryName: values.inventoryCategoryName,
                    description: values.description,
                    isActive: values.isActive,

                }
                updateInventoryCategoryMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.INVENTORY_ITEM_MASTER) {

                const payload = {
                    id: values.id,
                    inventoryCategoryCode: values.inventoryCategoryCode,
                    itemName: values.itemName,
                    description: values.description,
                    unit: values.unit,
                    rate: values.rate,
                    dependentItemCategoryCode: values.dependentItemCategoryCode,
                    isActive: values.isActive,
                }

                updateInventoryItemMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            }

            else if (props.reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE) {
                const payload = {
                    id: values.id,
                    itemCode: values.itemCode,
                    quantity: values.quantity,
                    asOfDate: values.asOfDate,
                    isActive: values.isActive,
                }


                updateInventoryOpeningBalanceMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            }

            else if (props.reportName === REPORT_NAME.INVENTORY_TRANSACTIONS) {

                const payload = {
                    id: values.id,
                    itemCode: values.itemCode,
                    date: values.date,
                    qtyIn: values.qtyIn,
                    qtyOut: values.qtyOut,
                    relatedVoucherID: values.relatedVoucherID,
                    isActive: values.isActive,
                }

                updateInventoryTransactionsMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            }
        }
    };


    useEffect(() => {
        if (saveInventoryCategoryMasterResponse.isSuccess) {
            const response: any = saveInventoryCategoryMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.INVENTORY_CATEGORY_MASTER,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

            alertMessage("Inventory Category Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        }
    }, [saveInventoryCategoryMasterResponse.isSuccess]);

    useEffect(() => {
        if (saveInventoryOpeningBalanceMasterResponse.isSuccess) {
            const response: any = saveInventoryOpeningBalanceMasterResponse.data;


            const payload = {
                tableName: REPORT_NAME.INVENTORY_OPENING_BALANCE,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });



            alertMessage("Inventory Opening Balance added successfully", "success");
            props.setCall("Y");
            handleClose();
        }
    }, [saveInventoryOpeningBalanceMasterResponse.isSuccess]);


    useEffect(() => {
        if (updateInventoryCategoryMasterResponse.isSuccess) {
            const response: any = updateInventoryCategoryMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.INVENTORY_CATEGORY_MASTER,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: inventoryCategoryMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

            alertMessage("Inventory Category Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        }
    }, [updateInventoryCategoryMasterResponse.isSuccess]);



    useEffect(() => {
        if (updateInventoryItemMasterResponse.isSuccess) {
            const response: any = updateInventoryItemMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.INVENTORY_ITEM_MASTER,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: inventoryItemMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

            alertMessage("Inventory Item Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        }
    }, [updateInventoryItemMasterResponse.isSuccess]);



    useEffect(() => {
        if (saveInventoryTransactionsMasterResponse.isSuccess) {
            const response: any = saveInventoryTransactionsMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.INVENTORY_TRANSACTIONS,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

            alertMessage("Inventory Transaction added successfully", "success");
            props.setCall("Y");
            handleClose();
        }
    }, [saveInventoryTransactionsMasterResponse.isSuccess]);


    useEffect(() => {
        if (saveInventoryItemMasterResponse.isSuccess) {
            const response: any = saveInventoryItemMasterResponse.data;


            const payload = {
                tableName: REPORT_NAME.INVENTORY_ITEM_MASTER,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });


            alertMessage("Inventory Item Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        }
    }, [saveInventoryItemMasterResponse.isSuccess]);



    useEffect(() => {
        if (updateInventoryOpeningBalanceMasterResponse.isSuccess) {
            const response: any = updateInventoryOpeningBalanceMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.INVENTORY_OPENING_BALANCE,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: inventoryOpeningBalanceMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

            alertMessage("Inventory Opening Balance updated successfully", "success");
            props.setCall("Y");
            handleClose();
        }
    }, [updateInventoryOpeningBalanceMasterResponse.isSuccess]);



    useEffect(() => {
        if (updateInventoryTransactionsMasterResponse.isSuccess) {
            const response: any = updateInventoryTransactionsMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.INVENTORY_TRANSACTIONS,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: inventoryTransactionsMasterByIdResponse?.data,
                newValue: response,
            };
            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });


            alertMessage("Inventory Transaction updated successfully", "success");
            props.setCall("Y");
            handleClose();
        }
    }, [updateInventoryTransactionsMasterResponse.isSuccess]);

    useEffect(() => {
        if (inventoryCategoryMasterByIdResponse.isSuccess) {
            setGetByIdData(inventoryCategoryMasterByIdResponse.data);
        } else if (inventoryCategoryMasterByIdResponse.isError) {
            let response: any = inventoryCategoryMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [inventoryCategoryMasterByIdResponse.isSuccess, inventoryCategoryMasterByIdResponse.isError]);

    useEffect(() => {
        if (inventoryItemMasterByIdResponse.isSuccess) {
            setGetByIdData(inventoryItemMasterByIdResponse.data);
        } else if (inventoryItemMasterByIdResponse.isError) {
            let response: any = inventoryItemMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [inventoryItemMasterByIdResponse.isSuccess, inventoryItemMasterByIdResponse.isError]);



    useEffect(() => {
        if (inventoryOpeningBalanceMasterByIdResponse.isSuccess) {
            setGetByIdData(inventoryOpeningBalanceMasterByIdResponse.data);
        } else if (inventoryOpeningBalanceMasterByIdResponse.isError) {
            let response: any = inventoryOpeningBalanceMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [inventoryOpeningBalanceMasterByIdResponse.isSuccess, inventoryOpeningBalanceMasterByIdResponse.isError]);


    useEffect(() => {
        if (inventoryTransactionsMasterByIdResponse.isSuccess) {
            setGetByIdData(inventoryTransactionsMasterByIdResponse.data);
        } else if (inventoryTransactionsMasterByIdResponse.isError) {
            let response: any = inventoryTransactionsMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [inventoryTransactionsMasterByIdResponse.isSuccess, inventoryTransactionsMasterByIdResponse.isError]);




    const handleBulkUpload = (e: any) => {
        const file = e.target.files[0];
        const fileName = e.target.files[0].name;
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        if (extFile == "xlsx") {
            setFile(e.target.files[0]);
        } else {
            alertMessage("Only xlsx files are allowed!", "error");
        }
    };



    const handleBulkSave = () => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            const formData = new FormData();
            if (file) {
                formData.append('file', file);
            }

            if (props.reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER) {
                bulkSaveInventoryCategoryMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            } else if (props.reportName === REPORT_NAME.INVENTORY_ITEM_MASTER) {
                bulkSaveInventoryItemMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            }
            else if (props.reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE) {
                bulkSaveInventoryOpeningBalanceMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            }
            else if (props.reportName === REPORT_NAME.INVENTORY_TRANSACTIONS) {
                bulkSaveInventoryTransactionsMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            }

        }
    }


    // Inventory Category Master - Bulk Upload
    useEffect(() => {
        if (bulkSaveInventoryCategoryMasterResponse.isSuccess) {
            const response: any = bulkSaveInventoryCategoryMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.INVENTORY_CATEGORY_MASTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Inventory Category Master uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveInventoryCategoryMasterResponse.isError) {
            const response: any = bulkSaveInventoryCategoryMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        bulkSaveInventoryCategoryMasterResponse.isSuccess,
        bulkSaveInventoryCategoryMasterResponse.isError
    ]);

    // Inventory Opening Balance Master - Bulk Upload
    useEffect(() => {
        if (bulkSaveInventoryOpeningBalanceMasterResponse.isSuccess) {
            const response: any = bulkSaveInventoryOpeningBalanceMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.INVENTORY_OPENING_BALANCE,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Inventory Opening Balance Master uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveInventoryOpeningBalanceMasterResponse.isError) {
            const response: any = bulkSaveInventoryOpeningBalanceMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        bulkSaveInventoryOpeningBalanceMasterResponse.isSuccess,
        bulkSaveInventoryOpeningBalanceMasterResponse.isError
    ]);

    // Inventory Transactions Master - Bulk Upload
    useEffect(() => {
        if (bulkSaveInventoryTransactionsMasterResponse.isSuccess) {
            const response: any = bulkSaveInventoryTransactionsMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.INVENTORY_TRANSACTIONS,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Inventory Transactions Master uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveInventoryTransactionsMasterResponse.isError) {
            const response: any = bulkSaveInventoryTransactionsMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        bulkSaveInventoryTransactionsMasterResponse.isSuccess,
        bulkSaveInventoryTransactionsMasterResponse.isError
    ]);

    // Inventory Item Master - Bulk Upload
    useEffect(() => {
        if (bulkSaveInventoryItemMasterResponse.isSuccess) {
            const response: any = bulkSaveInventoryItemMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.INVENTORY_ITEM_MASTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Inventory Item Master uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveInventoryItemMasterResponse.isError) {
            const response: any = bulkSaveInventoryItemMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        bulkSaveInventoryItemMasterResponse.isSuccess,
        bulkSaveInventoryItemMasterResponse.isError
    ]);




    useEffect(() => {
        if (findAllInventoryCategoryMastersResponse.isSuccess) {
            dispatch(setInventoryCategoryMasterList(findAllInventoryCategoryMastersResponse));
        } else if (findAllInventoryCategoryMastersResponse.isError) {
            let response: any = findAllInventoryCategoryMastersResponse.error;
            alertMessage(response, "error");
        }
    }, [findAllInventoryCategoryMastersResponse.isSuccess, findAllInventoryCategoryMastersResponse.isError]);


    useEffect(() => {
        if (findAllInventoryItemMastersResponse.isSuccess) {
            dispatch(setInventoryItemMasterList(findAllInventoryItemMastersResponse));
        } else if (findAllInventoryItemMastersResponse.isError) {
            let response: any = findAllInventoryItemMastersResponse.error;
            alertMessage(response, "error");
        }
    }, [findAllInventoryItemMastersResponse.isSuccess, findAllInventoryItemMastersResponse.isError]);


    useEffect(() => {
        if (findAllVoucherFinanceMastersResponse.isSuccess) {
            dispatch(setAllVoucherFinance(findAllVoucherFinanceMastersResponse.data));
        } else if (findAllVoucherFinanceMastersResponse.isError) {
            let response: any = findAllVoucherFinanceMastersResponse.error;
            alertMessage(response, "error");
        }
    }, [findAllVoucherFinanceMastersResponse.isSuccess, findAllVoucherFinanceMastersResponse.isError]);




    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                // dialogClassName={"modal-90w"}
                {...(
                    props.reportName === REPORT_NAME.USER_SUBSCRIBER || props.reportName === REPORT_NAME.USER_GROUP
                        ? { dialogClassName: "modal-90w" }
                        : { size: "lg" } // default to lg for all others
                )}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold text-accent" style={{ fontSize: "1rem" }}>
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {props.reportName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        saveInventoryCategoryMasterResponse.isLoading ||
                            saveInventoryItemMasterResponse.isLoading ||
                            saveInventoryOpeningBalanceMasterResponse.isLoading ||
                            saveInventoryTransactionsMasterResponse.isLoading ||

                            bulkSaveInventoryCategoryMasterResponse.isLoading ||
                            bulkSaveInventoryItemMasterResponse.isLoading ||
                            bulkSaveInventoryOpeningBalanceMasterResponse.isLoading ||
                            bulkSaveInventoryTransactionsMasterResponse.isLoading ||

                            updateInventoryCategoryMasterResponse.isLoading ||
                            updateInventoryItemMasterResponse.isLoading ||
                            updateInventoryOpeningBalanceMasterResponse.isLoading ||
                            updateInventoryTransactionsMasterResponse.isLoading ||

                            inventoryCategoryMasterByIdResponse.isLoading ||
                            inventoryItemMasterByIdResponse.isLoading ||
                            inventoryOpeningBalanceMasterByIdResponse.isLoading ||
                            inventoryTransactionsMasterByIdResponse.isLoading ||

                            findAllInventoryCategoryMastersResponse.isLoading ||
                            findAllInventoryItemMastersResponse.isLoading ||
                            findAllVoucherFinanceMastersResponse.isLoading
                            ? <Loading />
                            : ""
                    }
                    {props.actionType === ACTION_TYPE.ADD_ACTION && (
                        <ul className="nav nav-tabs mb-3" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'manual' ? 'active text-accent' : 'text-secondary'}`}
                                    onClick={() => setActiveTab('manual')}
                                >
                                    Manual Entry
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'bulk' ? 'active text-accent' : 'text-secondary'}`}
                                    onClick={() => setActiveTab('bulk')}
                                >
                                    Bulk Upload
                                </button>
                            </li>
                        </ul>
                    )}

                    {activeTab === "manual" && (
                        <Formik
                            enableReinitialize={true}
                            initialValues={
                                props.reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER
                                    ? {
                                        id: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.id || "" : "",
                                        inventoryCategoryName: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.inventoryCategoryName || "" : "",
                                        description: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.description || "" : "",
                                        isActive: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.isActive ?? true : true,
                                    }
                                    : props.reportName === REPORT_NAME.INVENTORY_ITEM_MASTER
                                        ? {
                                            id: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.id || "" : "",
                                            inventoryCategoryCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.inventoryCategoryCode || "" : "",
                                            itemName: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.itemName || "" : "",
                                            description: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.description || "" : "",
                                            unit: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.unit || "" : "",
                                            rate: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.rate || 0 : 0,
                                            dependentItemCategoryCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.dependentItemCategoryCode || "" : "",
                                            isActive: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.isActive ?? true : true,
                                        }
                                        : props.reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE
                                            ? {
                                                id: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.id ?? 0 : 0,
                                                itemCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.itemCode ?? 0 : 0,
                                                quantity: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.quantity ?? 0 : 0,
                                                asOfDate: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.asOfDate : "",
                                                isActive: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.isActive ?? true : true,
                                            }
                                            : {
                                                id: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.id ?? 0 : 0,
                                                itemCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.itemCode ?? 0 : 0,
                                                date: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.date : "",
                                                qtyIn: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.qtyIn ?? 0 : 0,
                                                qtyOut: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.qtyOut ?? 0 : 0,
                                                relatedVoucherID: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.relatedVoucherID ?? 0 : 0,
                                                isActive: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.isActive ?? true : true,
                                            }
                            }
                            onSubmit={handleSubmit}
                        >
                            {({ values, setFieldValue, handleChange }) => (
                                <Form>
                                    <div>
                                        {props.reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER ? (
                                            <div >
                                                {/* Left Column */}
                                                {/* Inventory Category Name */}
                                                <label className="form-label">
                                                    Inventory Category Name <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="inventoryCategoryName"
                                                    value={values.inventoryCategoryName}
                                                    required
                                                    onChange={(e) => setFieldValue("inventoryCategoryName", e.target.value)}
                                                />

                                                {/* Right Column */}
                                                {/* Description */}
                                                <label className="form-label">Description</label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="description"
                                                    value={values.description}
                                                    required
                                                    onChange={(e) => setFieldValue("description", e.target.value)}
                                                />
                                            </div>

                                        ) : props.reportName === REPORT_NAME.INVENTORY_ITEM_MASTER ? (
                                            <div >
                                                {/* Inventory Category Dropdown */}
                                                <label className="form-label mt-3">Inventory Category</label>
                                                <select
                                                    className="form-select form-select-sm"
                                                    name="inventoryCategoryCode"
                                                    value={values.inventoryCategoryCode}
                                                    onChange={(e) => setFieldValue("inventoryCategoryCode", e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select Inventory Category</option>
                                                    {allInventoryCategoryData.map((item: any, idx: number) => (
                                                        <option key={idx} value={item.id}>
                                                            {item.id} - {item.inventoryCategoryName}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* Item Name */}
                                                <label className="form-label mt-3">Item Name</label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="itemName"
                                                    value={values.itemName}
                                                    onChange={(e) => setFieldValue("itemName", e.target.value)}
                                                    required
                                                />

                                                {/* Description */}
                                                <label className="form-label mt-3">Description</label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="description"
                                                    value={values.description}
                                                    onChange={(e) => setFieldValue("description", e.target.value)}
                                                />

                                                {/* Unit */}
                                                <label className="form-label mt-3">Unit</label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="unit"
                                                    value={values.unit}
                                                    onChange={(e) => setFieldValue("unit", e.target.value)}
                                                />

                                                {/* Rate */}
                                                <label className="form-label mt-3">Rate</label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="rate"
                                                    value={values.rate}
                                                    onChange={(e) => setFieldValue("rate", e.target.value)}
                                                />

                                                {/* Dependent Item Category Dropdown */}
                                                <label className="form-label mt-3">Dependent Item Category</label>
                                                <select
                                                    className="form-select form-select-sm"
                                                    name="dependentItemCategoryCode"
                                                    value={values.dependentItemCategoryCode}
                                                    onChange={(e) => setFieldValue("dependentItemCategoryCode", e.target.value)}
                                                >
                                                    <option value="">Select Dependent Category</option>
                                                    {allInventoryItemMasterData.map((item: any, idx: number) => (
                                                        <option key={idx} value={item.id}>
                                                            {item.id} - {item.itemName}
                                                        </option>
                                                    ))}
                                                </select>

                                            </div>
                                        ) : props.reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE ? (
                                            <div >
                                                {/* Item Code Dropdown */}
                                                <label className="form-label me-2">
                                                    Item Code <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <select
                                                    className="form-select form-select-sm"
                                                    name="itemCode"
                                                    value={values.itemCode}
                                                    onChange={(e) => setFieldValue("itemCode", e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select Item</option>
                                                    {allInventoryItemMasterData && allInventoryItemMasterData.map((item: any, idx: any) => (
                                                        <option key={idx} value={item.id}>
                                                            {item.id} - {item.itemName}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* Quantity Input */}
                                                <label className="form-label me-2">
                                                    Quantity <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="number"
                                                    name="quantity"
                                                    value={values.quantity}
                                                    onChange={(e) => setFieldValue("quantity", e.target.value)}
                                                    required
                                                />

                                                {/* As of Date Picker */}
                                                <label className="form-label mt-1">
                                                    As of Date <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <DatePicker
                                                    className="w-100"
                                                    format="YYYY-MM-DD"
                                                    required
                                                    value={values.asOfDate ? dayjs(values.asOfDate, "YYYY-MM-DD") : null}
                                                    onChange={(date) =>
                                                        setFieldValue("asOfDate", date ? date.format("YYYY-MM-DD") : "")
                                                    }
                                                    getPopupContainer={(trigger) =>
                                                        (trigger.parentNode as HTMLElement) || document.body
                                                    }
                                                />
                                            </div>

                                        ) : (
                                            <div className="row">
                                                {/* Item Code Dropdown */}
                                                <div className="col-12 col-md-6">
                                                    <label className="form-label">
                                                        Item Code <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="itemCode"
                                                        value={values.itemCode}
                                                        onChange={(e) => setFieldValue("itemCode", e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select Item</option>
                                                        {allInventoryItemMasterData && allInventoryItemMasterData.map((item: any, idx: any) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.itemName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                {/* Date Picker */}
                                                <div className="col-12 col-md-6">
                                                    <label className="form-label">
                                                        Transaction Date <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <DatePicker
                                                        className="w-100"
                                                        format="YYYY-MM-DD"
                                                        required
                                                        value={values.date ? dayjs(values.date, "YYYY-MM-DD") : dayjs()} // default today
                                                        onChange={(date) =>
                                                            setFieldValue("date", date ? date.format("YYYY-MM-DD") : "")
                                                        }
                                                        getPopupContainer={(trigger) =>
                                                            (trigger.parentNode as HTMLElement) || document.body
                                                        }
                                                    />
                                                </div>


                                                {/* Qty In */}
                                                <div className="col-12 col-md-6 mt-3">
                                                    <label className="form-label">
                                                        Quantity In <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="number"
                                                        name="qtyIn"
                                                        value={values.qtyIn}
                                                        onChange={(e) => setFieldValue("qtyIn", e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                {/* Qty Out */}
                                                <div className="col-12 col-md-6 mt-3">
                                                    <label className="form-label">
                                                        Quantity Out <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="number"
                                                        name="qtyOut"
                                                        value={values.qtyOut}
                                                        onChange={(e) => setFieldValue("qtyOut", e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                {/* Related Voucher Dropdown */}
                                                <div className="col-12 col-md-6 mt-3">
                                                    <label className="form-label">
                                                        Related Voucher <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="relatedVoucherID"
                                                        value={values.relatedVoucherID}
                                                        onChange={(e) => setFieldValue("relatedVoucherID", e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select Voucher</option>
                                                        {allVoucherFinanceData && allVoucherFinanceData.map((voucher: any, idx: any) => (
                                                            <option key={idx} value={voucher.id}>
                                                                {voucher.id} - {voucher.party} - {voucher.narration} -₹{voucher.amount}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                        )}
                                    </div>
                                    <div className="d-flex flex-row justify-content-center">
                                        <button
                                            type="submit"
                                            className={`btn btn-primary btn-block mt-3 mx-2 btn-width bg-accent`}
                                        >
                                            {props.actionType === ACTION_TYPE.ADD_ACTION ? "Save" : "Update"}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                            onClick={handleClose}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                    )}
                    {activeTab === "bulk" && (
                        <div className="border p-3 rounded">
                            <div className="mb-3">
                                <label htmlFor="xlsxUpload" className="form-label">
                                    Upload .xlsx File <span className="text-danger">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    accept=".xlsx"
                                    id="xlsxUpload"
                                    onChange={handleBulkUpload}
                                />
                            </div>
                            <a
                                href={`/templates/${props.reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER
                                    ? "INVENTORY_CATEGORY_MASTER"
                                    : props.reportName === REPORT_NAME.INVENTORY_ITEM_MASTER
                                        ? "INVENTORY_ITEM_MASTER"
                                        : props.reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE
                                            ? "INVENTORY_OPENING_BALANCE"
                                            : props.reportName === REPORT_NAME.INVENTORY_TRANSACTIONS
                                                ? "INVENTORY_TRANSACTIONS"
                                                : ""
                                    }.xlsx`}
                                download
                                className="btn btn-outline-secondary"
                            >
                                Download Sample .xlsx Template
                            </a>
                            <button
                                className="btn btn-primary mx-2 bg-accent"
                                onClick={handleBulkSave}
                                disabled={!file}
                            >
                                Save
                            </button>
                        </div>
                    )}


                </Modal.Body>
            </Modal >
        </>
    );

};

export default InventoryReportData